import React from "react";
import CusInput from "../../../mui/custom_input/CusInput";
import IconAddress from "../../../mui/JSXIcons/IconAddress";

export default function UPIField() {
  return (
    <>
      <CusInput
        iconJSXstart={<IconAddress />}
        name={"accNumber"}
        placeholder={"VPA (user@paytm)"}
        required
      />
    </>
  );
}
